import {Button, Form, Input, message} from 'antd'
import React from 'react'
import API from '../../api'
import {newSuggestion} from '../../api/suggestion'

const SuggestionCom = () => {
  const [suForm] = Form.useForm()
  //处理表单提交
  const onFinish = (values: any) => {
    let su = newSuggestion()
    su.info = values.info
    su.user = JSON.parse(sessionStorage.getItem('user-info') || '{}')
    API.addSuggestion(su).then(() => {
      suForm.resetFields()
      message.success({
        content: '感谢您提供的宝贵建议',
        duration: 3,
      })
    })
  }
  return (
    <>
      <div className="suggestions-group">
        <div className="suggestions-group-header">
          <div className="advice-title">
            <span>建议</span>
          </div>
        </div>
        <Form name="suggestions-form" onFinish={onFinish} form={suForm}>
          <div className="suggestions-group-content">
            <Form.Item name="info">
              <Input.TextArea placeholder="请在此输入您的使用反馈或建议" rows={14} />
            </Form.Item>
          </div>
          <div className="suggestions-group-bottom">
            <Form.Item>
              <Button type="primary" htmlType="submit">
                提交
              </Button>
            </Form.Item>
          </div>
        </Form>
      </div>
    </>
  )
}

export default SuggestionCom
